module.exports = __webpack_public_path__ + "static/media/swipe_arrow.ac70ad46.svg";